export const UPDATE = 'UPDATE';
export const LANGUAGE_UPDATE = 'LANGUAGE_UPDATE';
export const FILE_UPDATE = 'FILE_UPDATE';
export const FILE_DELETE = 'FILE_DELETE';
